export const DATE_FORMATTER = 'YYYY-MM-DD';
export const DATE_HOUR_MIN_FORMATTER = 'YYYY-MM-DD HH: mm';
export const DATE_FORMATTER_TO_MONTH = 'YYYY-MM';
export const USER_ENROLLMENT_DISABLED_DAYS_BEFORE_HIRE_DATE = 15;
export const USER_ENROLLMENT_DISABLED_DAYS_AFTER_HIRE_DATE = 14;
